import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { useAuth } from './auth';

const ClienteContext = createContext({});

function ClienteProvider({ children }) {
  const [clienteSelecionado, setClienteSelecionado] = useState({});
  const { permissoes } = useAuth();
  const [navegarMenu, setNavegarMenu] = useState(true);

  const selectClient = useCallback(
    async ({ id, contaId, conta, nome, documento, isAdmin = true }) => {
      setClienteSelecionado({ id, contaId, conta, nome, documento, isAdmin });
    },
    []
  );

  const verificarClienteSelecionado = useCallback(() => {
    if (
      permissoes.includes('ListarTodosClientes') &&
      clienteSelecionado &&
      !clienteSelecionado.isAdmin
    ) {
      // history.push('/selecionar-cliente/');
    }
  }, [permissoes, clienteSelecionado]);

  const updateNavegarMenu = useCallback(async value => {
    setNavegarMenu(value);
  }, []);

  const clienteContextValue = useMemo(
    () => ({
      selectClient,
      clienteSelecionado,
      verificarClienteSelecionado,
      updateNavegarMenu,
      navegarMenu,
    }),
    [
      clienteSelecionado,
      navegarMenu,
      selectClient,
      updateNavegarMenu,
      verificarClienteSelecionado,
    ]
  );

  return (
    <ClienteContext.Provider value={clienteContextValue}>
      {children}
    </ClienteContext.Provider>
  );
}

function useCliente() {
  const context = useContext(ClienteContext);
  return context;
}

ClienteProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { useCliente, ClienteProvider };
